export const ADMIN_FIELD_LABELS: Record<string, string> = {
  discipline: 'Discipline',
  technote_type: 'Technote Type',
  scope: 'Scope',
  customer: 'Customer',
  confidentiality: 'Confidentiality',
  brand: 'Brand',
  asset_type: 'Asset Type',
  technology_type: 'Technology Type',
}
